__turbopack_context__.v({
  "aspectRaction16to9": "ImageComponent-module-scss-module__bhhnFG__aspectRaction16to9",
  "aspectRaction1to1": "ImageComponent-module-scss-module__bhhnFG__aspectRaction1to1",
  "aspectRaction4to3": "ImageComponent-module-scss-module__bhhnFG__aspectRaction4to3",
  "captionContainer": "ImageComponent-module-scss-module__bhhnFG__captionContainer",
  "copyCardContainer": "ImageComponent-module-scss-module__bhhnFG__copyCardContainer",
  "copyCardDeskTop": "ImageComponent-module-scss-module__bhhnFG__copyCardDeskTop",
  "copyCardMobile": "ImageComponent-module-scss-module__bhhnFG__copyCardMobile",
  "desktopImage": "ImageComponent-module-scss-module__bhhnFG__desktopImage",
  "imageCaption": "ImageComponent-module-scss-module__bhhnFG__imageCaption",
  "imageContainer": "ImageComponent-module-scss-module__bhhnFG__imageContainer",
  "mobileImage": "ImageComponent-module-scss-module__bhhnFG__mobileImage",
  "noHide": "ImageComponent-module-scss-module__bhhnFG__noHide",
  "noWrap": "ImageComponent-module-scss-module__bhhnFG__noWrap",
  "sectionContainer": "ImageComponent-module-scss-module__bhhnFG__sectionContainer",
});
